
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.4 2.3A22.06 22.06 0 006.1 38.07L3 45.53l7.63-3.16A22.07 22.07 0 1023.4 2.3z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"23.27","cy":"24.13","r":"13.47","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M30.43 27.17a7.81 7.81 0 01-7.19 4.76h.05a7.78 7.78 0 01-7.18-4.76","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"17.24","cy":"21.18","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"29.29","cy":"21.18","r":"1.5","fill":"#241f21"}}),_c('path',{attrs:{"d":"M44.91 27.11a15.32 15.32 0 0110.45 24.77l2.15 5.19-5.3-2.2a15.33 15.33 0 01-23.84-9.18","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"43.34","cy":"42.37","r":"1.22","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"50.33","cy":"42.37","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"43.33","cy":"42.37","r":"1.5","fill":"#241f21"}})])
          )
        }
      }
    